export const RISK_MODERATE_LIMIT = 62.5;

export const RISK_ELEVATED_LIMIT = 68;

export const RISK_SIGNIFICANT_LIMIT = 74;

export const RISK_HIGH_LIMIT = 80;

export const RISK_VERY_HIGH_LIMIT = 86;

export const RISK_EXTREME_LIMIT = 94;
